import {
  LoadingButton_default
} from "./chunk-5UPEKN6R.mjs";
import {
  SidePanelHeader
} from "./chunk-A2UNT4DX.mjs";

// src/internal/components/two-factor-panel/two-factor-complete-panel.tsx
import * as React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useAuthContext, useTwoFactorActivationContext } from "@clara/auth";
import { useAsyncFn } from "@clara/hooks";
import { useT } from "@clara/locale";
import { Flex, Banner } from "@clara/ui";
import { jsx, jsxs } from "react/jsx-runtime";
function SidePanel() {
  const { t } = useT(["auth", "common"]);
  const { setPanelFormData } = useAuthContext();
  const activation = useTwoFactorActivationContext();
  const [downloading, download] = useAsyncFn(async () => {
    var _a;
    const response = await ((_a = activation.QRCode.value) == null ? void 0 : _a.download());
    return response;
  }, [activation.QRCode.value]);
  React.useEffect(() => {
    return () => {
      activation.confirm();
    };
  });
  React.useEffect(() => {
    setPanelFormData({
      payload: {
        loading: downloading.loading,
        onClick: async () => download()
      }
    });
  }, [download, downloading.loading, setPanelFormData]);
  return /* @__PURE__ */ jsxs(Stack, { spacing: 3, width: "100%", children: [
    /* @__PURE__ */ jsx(Stack, { spacing: 2, children: /* @__PURE__ */ jsx(Typography, { fontWeight: "600", children: t("twofactor.activation.success.warning") }) }),
    /* @__PURE__ */ jsx(
      Flex,
      {
        component: "pre",
        align: "flex-start",
        bgcolor: "grey.50",
        px: 2,
        py: 1,
        border: "1px solid",
        borderColor: "grey.300",
        borderRadius: 2,
        children: activation.QRCode.value && activation.QRCode.value.codes.join("\r\n")
      }
    ),
    /* @__PURE__ */ jsx(Stack, { spacing: 4, children: /* @__PURE__ */ jsx(Banner, { status: "info", children: t("twofactor.activation.success.disclaimer") }) })
  ] });
}
var ActivationCompletePanelHeader = () => {
  const { t } = useT(["auth"]);
  return /* @__PURE__ */ jsx(
    SidePanelHeader,
    {
      variant: "alternate",
      headline: t("twofactor.activation.success.headline")
    }
  );
};
var ActivationCompletePanelFooter = () => {
  var _a, _b;
  const { t } = useT(["common"]);
  const { panelFormData } = useAuthContext();
  return /* @__PURE__ */ jsx(
    LoadingButton_default,
    {
      variant: "contained",
      loading: (_a = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _a.loading,
      onClick: (_b = panelFormData == null ? void 0 : panelFormData.payload) == null ? void 0 : _b.onClick,
      children: t("download", { ns: "common" })
    }
  );
};
var TwofactorCompleteSidePanel = [
  {
    children: [
      {
        element: /* @__PURE__ */ jsx(SidePanel, {}),
        header: /* @__PURE__ */ jsx(ActivationCompletePanelHeader, {}),
        footer: /* @__PURE__ */ jsx(ActivationCompletePanelFooter, {})
      }
    ]
  }
];
var two_factor_complete_panel_default = TwofactorCompleteSidePanel;

export {
  two_factor_complete_panel_default
};
